export const categories = [
  {
    id: 'live-scene',
    name: '娱乐现场',
    description: '活动、见面会、开机现场的公开见闻汇总',
    icon: 'ri-mic-line',
    count: 42,
  },
  {
    id: 'hot-trend',
    name: '网络热榜',
    description: '热榜话题的来龙去脉与关键节点梳理',
    icon: 'ri-fire-line',
    count: 58,
  },
  {
    id: 'circle',
    name: '圈层动态',
    description: '不同兴趣圈子里正在讨论的新鲜事',
    icon: 'ri-group-line',
    count: 31,
  },
  {
    id: 'on-site',
    name: '活动现场',
    description: '展映、漫展、音乐节的排队与打卡记录',
    icon: 'ri-map-pin-line',
    count: 27,
  },
  {
    id: 'backstage',
    name: '幕后花絮',
    description: '台前之外被人提到的那些小细节',
    icon: 'ri-magic-line',
    count: 19,
  },
];